import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
`
export const Main = styled.div`
  flex: 1;
`
export const Side = styled.div`
  flex: 0 0 19rem;
  margin-right: 2rem;
`
